import { render, staticRenderFns } from "./BooleanQuestion.vue?vue&type=template&id=63e6838c&scoped=true"
import script from "./BooleanQuestion.vue?vue&type=script&lang=js"
export * from "./BooleanQuestion.vue?vue&type=script&lang=js"
import style0 from "./BooleanQuestion.vue?vue&type=style&index=0&id=63e6838c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e6838c",
  null
  
)

export default component.exports